import * as React from "react";
import { ContactCard } from "./ContactCard";
import Icon24 from "../../img/b19d0cba7caca5d2da234a859885e15d09d00fa106cea4702598366c599dbda2.svg";

export function ContactSection({ title, contacts, onRefresh }) {
  // Add state for section visibility
  const [isExpanded, setIsExpanded] = React.useState(true);
  
  // Check if it's the Vendor section
  const isVendorSection = title === "Vendors";
  const isNettlesSection = title === "Nettles Project Team";

  return (
    <div className="flex flex-col w-full mb-6">
      <div className="flex flex-col px-12 py-7 w-full bg-white rounded-xl shadow-md max-md:px-5 max-md:max-w-full">
        <div className="flex items-center justify-between pb-4 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <div className="text-xl font-semibold text-zinc-800">
              {title}
            </div>
            <button 
              className="text-red-600 text-sm hover:underline"
              onClick={() => {
                // Trigger the modal with the specific section type
                const event = new CustomEvent('openContactModal', {
                  detail: { sectionType: title }
                });
                window.dispatchEvent(event);
              }}
            >
              + Update Contacts
            </button>
          </div>
          {/* Add click handler to toggle section */}
          <img
            loading="lazy"
            src={Icon24}
            className={`aspect-square w-[12px] cursor-pointer transition-transform duration-300 ${
              isExpanded ? 'rotate-180' : ''
            }`}
            alt={isExpanded ? "Collapse section" : "Expand section"}
            onClick={() => setIsExpanded(!isExpanded)}
          />
        </div>
        {/* Conditionally render content based on isExpanded state */}
        {isExpanded && (
          <div className={`${isVendorSection ? "flex flex-wrap gap-10" : "grid grid-cols-5 gap-x-10 gap-y-6 items-start w-full max-md:grid-cols-2 max-md:max-w-full max-sm:grid-cols-[1fr]"} mt-6`}>
            {contacts.map((group, index) => (
              <div key={index} className={`flex flex-col ${isVendorSection ? 'w-auto' : 'w-full'}`}>
                {!isVendorSection && group.contacts.length > 0 && (
                  <div className="flex flex-col">
                    <div className="text-lg font-medium text-zinc-800 mb-4">
                      {group.title}:
                    </div>
                    {/* For Nettles Project Team, only show the latest contact */}
                    {isNettlesSection ? (
                      <ContactCard 
                        contact={group.contacts[group.contacts.length - 1]}
                        hasChat={true}
                        sectionType={title}
                        onSuccess={onRefresh}
                      />
                    ) : (
                      // For other sections, show all contacts with dividers
                      group.contacts.map((contact, cIndex) => (
                        <div key={cIndex}>
                          <ContactCard 
                            contact={contact}
                            hasChat={false}
                            sectionType={title}
                            onSuccess={onRefresh}
                          />
                          {cIndex < group.contacts.length - 1 && (
                            <div className="h-px bg-gray-200 my-4" />
                          )}
                        </div>
                      ))
                    )}
                  </div>
                )}
                {!isVendorSection && group.contacts.length === 0 && (
                  <>
                    <div className="text-lg font-medium text-zinc-800">
                      {group.title}:
                    </div>
                    <div className="text-gray-500 italic mt-2">
                      No contact found
                    </div>
                  </>
                )}
                {isVendorSection && (
                  <div className={`flex ${isVendorSection ? 'flex-row flex-wrap gap-10' : 'flex-col gap-8'}`}>
                    {group.contacts.length > 0 ? (
                      group.contacts.map((contact, cIndex) => (
                        <ContactCard key={cIndex} {...contact} />
                      ))
                    ) : (
                      <div className="text-gray-500 italic mt-2">
                        No contact found
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
